<!DOCTYPE html>
<html lang="en">

<head>
  <!-- Required meta tags -->
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
  <title>Mot de Passe Oublié</title>
  <!-- plugins:css -->

</head>

<body  *ngIf="!loading">
  <div class="container-scroller" >
    <div class="container-fluid page-body-wrapper full-page-wrapper">
      <div class="content-wrapper d-flex align-items-center auth px-0">
        <div class="row w-100 mx-0">
          <div class="col-lg-4 mx-auto">
            <div class="auth-form-light text-left py-5 px-4 px-sm-5">
              <div class="brand-logo" style="text-align: center;">
                <img src="assets/images.png" alt="logo">
              </div>
              <form [formGroup]="form" (ngSubmit)="onSubmit()">

                <div class="form-group">
                  <label for="email">E-mail :</label>

                  <input type="email" formControlName="email" id="email" class="form-control" [ngClass]="{ 'is-invalid': submitted && form.get('email')?.errors }" />
                  <div *ngIf="submitted && form.get('email')?.errors" class="invalid-feedback">
                    <div *ngIf="form.get('email')?.errors?.required">Email is required</div>
                    <div *ngIf="form.get('email')?.errors?.email">Invalid email format</div>
                  </div>
                

                </div>
           
          

                
                <div class="form-group" style="text-align: center;">
                  <button type="submit" class="btn btn-primary">Envoyer</button>

                </div>
                <div class="text-center mt-4 font-weight-light">
                  Already have an account? <a routerLink="/login" class="text-primary">Login</a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- content-wrapper ends -->
    </div>
    <!-- page-body-wrapper ends -->
  </div>
  <!-- container-scroller -->
  <!-- plugins:js -->
  
  <!-- endinject -->
</body>
<div *ngIf="loading" class="loading-overlay">
  <div class="spinner-container">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</div>
</html>